import { AApi } from "@/service/AApi";

const API = new AApi({
  url: "sx/loai-chat-thais",
});

export default API;
